import { render } from "./QuitKeuzePopup.vue?vue&type=template&id=1e46afbb&scoped=true"
import script from "./QuitKeuzePopup.vue?vue&type=script&lang=js"
export * from "./QuitKeuzePopup.vue?vue&type=script&lang=js"

import "./QuitKeuzePopup.vue?vue&type=style&index=0&id=1e46afbb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e46afbb"]])

export default __exports__